import { fetchAll, fetchFiltered, addUser, show, edit, fetchPartners } from '@/api/user'

const state = {
  all: [],
  isLoading: false,
  userById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const user = await show(id)
      commit('setUserById', user)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const users = await fetchAll()
      commit('setAll', users)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },
  
  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const users = await fetchFiltered(queriesParams)
      commit('setAll', users)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchPartners ({ dispatch, commit }) {
    try {
      const users = await fetchPartners()
      commit('setAll', users)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addUser(data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e)
    } finally {
      commit('setLoading', true)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.userById = null
  },

  setAll (state, users) {
    state.all = users
  },

  setUserById (state, user) {
    state.userById = {
      id: user.id,
      name: user.name,
      email: user.email,
      groups: user.groups,
      company: user.company.id,
      type: user.type,
      admin: user.admin,
      isActive: user.isActive
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
